import { createSlice } from "@reduxjs/toolkit";
import {
  createCommunicationAction,
  updateCommunicationAction,
  getCommunicationAction,
  deleteCommunicationAction,
} from "../../actions/Communication/communicationActions";

const initialState = {
  communications: [],
  loading: false,
  error: null,
  success: false,
  isCreated: false,
  isUpdated: false,
};

const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.isCreated = false;
      state.isUpdated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCommunicationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createCommunicationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.isCreated = true;
        state.communications.push(action.payload.data);
      })
      .addCase(createCommunicationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCommunicationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateCommunicationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.isUpdated = true;
        const index = state.communications.findIndex(
          (item) => item.communicationID === action.payload.data.communicationID,
        );
        if (index !== -1) {
          state.communications[index] = action.payload.data;
        }
      })
      .addCase(updateCommunicationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getCommunicationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommunicationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.communications = action.payload.data || [];
      })
      .addCase(getCommunicationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCommunicationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteCommunicationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.communications = state.communications.filter(
          (item) => item.communicationID !== action.payload.communicationID,
        );
      })
      .addCase(deleteCommunicationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetState } = communicationSlice.actions;
export default communicationSlice.reducer;
